import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Message, MessageRes, TicketRes, TicketsPageRequest } from 'src/app/shared/models/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  public baseUrl: string = environment.baseUrl;
  constructor(
    private http: HttpClient,
  ) { }

  public getAllTicket(page:TicketsPageRequest): Observable<TicketRes> {
    const query = new URLSearchParams(page as any)
    return this.http.get<TicketRes>(`${this.baseUrl}core/tickets/search?${query}`);
  }
  public sendMessage(ticketId: number, message: string): Observable<MessageRes> {
    return this.http.post<MessageRes>(`${this.baseUrl}core/tickets/${ticketId}/messages`, {message}, {headers:{
      showLoading: 'false'
    }});
  }
  public closeTicket(ticketId: number): Observable<MessageRes> {
    return this.http.get<MessageRes>(`${this.baseUrl}core/tickets/close/${ticketId}`);
  }
}
